// NO_MODIFY_THIS_FILE_BAKKA
import * as api from './api';
import * as actions from './actions';
import * as functions from './functions';
import activityReducer from './reducer';

const reducers = {
  activityData: activityReducer,
};

export {
  actions, api, functions, reducers,
};
